import {
  AlertTriangle, Sparkles, Calendar as CalendarIcon, Clock, ListChecks, Hourglass,
} from 'lucide-react';

// Color por defecto cuando un proyecto no tiene color asignado.
export const PROYECTO_COLOR_DEFAULT = '#06b6d4';

// Paleta para color del proyecto y de etiquetas.
export const COLORES = [
  { hex: '#06b6d4', nombre: 'Cyan' },
  { hex: '#3b82f6', nombre: 'Azul' },
  { hex: '#8b5cf6', nombre: 'Violeta' },
  { hex: '#ec4899', nombre: 'Rosa' },
  { hex: '#ef4444', nombre: 'Rojo' },
  { hex: '#f97316', nombre: 'Naranja' },
  { hex: '#10b981', nombre: 'Esmeralda' },
  { hex: '#64748b', nombre: 'Pizarra' },
];

// 4 categorías fijas del flujo. Cada proyecto define sub-estados dentro de ellas.
export const CATEGORIAS = [
  { key: 'por_hacer',  label: 'Por hacer',  color: '#64748b', defaultCollapsed: false },
  { key: 'en_curso',   label: 'En curso',   color: '#06b6d4', defaultCollapsed: false },
  { key: 'hecho',      label: 'Hecho',      color: '#10b981', defaultCollapsed: false },
  { key: 'cancelado',  label: 'Cancelado',  color: '#ef4444', defaultCollapsed: false },
];

export const CATEGORIA_ORDER = CATEGORIAS.map((c) => c.key);
export const CATEGORIA_LABEL = Object.fromEntries(CATEGORIAS.map((c) => [c.key, c.label]));
export const CATEGORIA_COLOR = Object.fromEntries(CATEGORIAS.map((c) => [c.key, c.color]));

// Prioridades en orden visual descendente (urgente arriba, sin prioridad abajo).
// El icono visual lo provee PriorityIcon en utils/displays.js (Flag-based, unificado
// con board, lista, calendario, gantt y modal de tarea).
export const PRIORIDADES = [
  { key: 'urgente', label: 'Urgente' },
  { key: 'alta',    label: 'Alta' },
  { key: 'media',   label: 'Media' },
  { key: 'baja',    label: 'Baja' },
  { key: 'ninguna', label: 'Sin prioridad' },
];

export const PRIORIDAD_ORDER = Object.fromEntries(PRIORIDADES.map((p, i) => [p.key, i]));
export const PRIORIDAD_LABEL = Object.fromEntries(PRIORIDADES.map((p) => [p.key, p.label]));

// Grupos para agrupar tareas por proximidad de fecha (Mis tareas, Lista).
export const GRUPOS_FECHA = [
  { key: 'vencidas', label: 'Vencidas',    icon: AlertTriangle, color: '#ef4444' },
  { key: 'hoy',      label: 'Hoy',         icon: Sparkles,      color: '#f59e0b' },
  { key: 'semana',   label: 'Esta semana', icon: CalendarIcon,  color: '#06b6d4' },
  { key: 'proximas', label: 'Próximas',    icon: Clock,         color: '#64748b' },
  // Congeladas: esperan a que se cierre una predecesora; su plazo no corre.
  { key: 'espera',   label: 'En espera',   icon: Hourglass,     color: '#6366f1' },
  { key: 'sin',      label: 'Sin fecha',   icon: ListChecks,    color: '#94a3b8' },
];

export const GRUPOS_FECHA_ORDER = GRUPOS_FECHA.map((g) => g.key);
